import { useEffect } from 'react';
import { useChannelCategoriesStore } from '../stores/channelCategories.store';

export const useChannelCategories = (opts: { loadOnMount?: boolean } = {}) => {
  const { loadOnMount = true } = opts;
  const { categories, isLoading, error, load } = useChannelCategoriesStore();

  useEffect(() => { if (loadOnMount) { load(); } }, [loadOnMount, load]);

  return { categories, isLoading, error, reload: load };
};
